import { RootState } from 'store';

export const selectReviewCycles = (state: RootState) => state.reviewCycles;

export const selectCyclesFilters = (state: RootState) =>
  state.reviewCycles.filters;

export const selectCyclesPagination = (state: RootState) =>
  state.reviewCycles.pagination;
